import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import ButtonMain from "@/components/buttons/button_main";
import ButtonGhost from "@/components/buttons/button_ghost";

export default function MatchModal({ open, listing, matchId = "m1", onClose }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const initial = (user?.name || user?.email || "You").slice(0, 1).toUpperCase();

  return (
    <AnimatePresence>
      {open && listing && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="relative w-full max-w-sm rounded-3xl bg-night-surface p-8 text-center shadow-ambient"
            initial={{ scale: 0.85, y: 24 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.92, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 22 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-center">
              <motion.div
                initial={{ x: -16, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.1 }}
                className="h-20 w-20 overflow-hidden rounded-full border-4 border-night-surface shadow-ambient"
              >
                <img src={listing.photos?.[0]} alt={listing.title} className="h-full w-full object-cover" />
              </motion.div>
              <motion.div
                initial={{ x: 16, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.18 }}
                className="-ml-4 flex h-20 w-20 items-center justify-center rounded-full border-4 border-night-surface bg-brand-primary text-2xl font-semibold text-white shadow-ambient"
              >
                {initial}
              </motion.div>
            </div>

            <h2 className="mt-5 font-display text-2xl font-semibold tracking-tight text-night-text">It's a match</h2>
            <p className="mt-2 text-sm text-night-sub">
              You and the lister of <span className="font-medium text-night-text">{listing.title}</span> liked each other.
            </p>

            <div className="mt-6 space-y-2.5">
              <ButtonMain full onClick={() => navigate(`/chat/${matchId}`)}>Say hello</ButtonMain>
              <ButtonGhost full onClick={onClose}>Keep swiping</ButtonGhost>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
